export default __webpack_public_path__ + "static/media/Toolbox.48c36148.svg";